<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <customModalSidebar :settings="customSidebarSettings"></customModalSidebar>
        <div class="top_filters_area">
        <div class="profiles_search">
            <b-form-input
                    v-model="searchProfile"
                    placeholder="Start typing to search"
                    class="search_votes"
            ></b-form-input>
            <div class="profiles_search_group">
                <div class="profiles_sort_by">
                    {{translate('admin_sortBy')}}:
                    <ul>
                        <li>
                            <div class="profiles_sort_link" @click="onSortChangedBy('name')"
                                 :class="{active:this.profilesConfig.orderBy == 'name'}">
                                {{translate('admin_sortByName')}}
                            </div>
                        </li>
                        <li>
                            <div class="profiles_sort_link" @click="onSortChangedBy('email')"
                                 :class="{active:this.profilesConfig.orderBy == 'email'}">
                                {{translate('admin_sortByEmail')}}
                            </div>
                        </li>
                        <li>
                            <div class="profiles_sort_link" @click="onSortChangedBy('date_added')"
                                 :class="{active:this.profilesConfig.orderBy == 'date_added'}">
                                {{translate('admin_sortByCreated')}}
                            </div>
                        </li>
                        <li>
                            <div class="profiles_sort_link" @click="onSortChangedBy('date_active')"
                                 :class="{active:this.profilesConfig.orderBy == 'date_active'}">
                                Activity
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="profiles_sort_dir">
                    Sort dir:
                    <ul>
                        <li>
                            <a class="profiles_sort_icon" @click="onSortChangedDir('asc')"
                               :class="{active:this.profilesConfig.orderDir == 'asc'}">
                                <img src="@/assets/icons/chevron-up-solid.svg" alt="" style="height: 20px">
                            </a>
                        </li>
                        <li>
                            <a class="profiles_sort_icon" @click="onSortChangedDir('desc')"
                               :class="{active:this.profilesConfig.orderDir == 'desc'}">
                                <img src="@/assets/icons/chevron-down-solid.svg" alt=""
                                     style="height: 20px">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <button @click="onAddUserClick()" style="max-width: 200px;">
            {{translate('createNewUser')}}
        </button>
        </div>
        <b-list-group class="profiles_list" @scroll="onListScrolled">
            <b-list-group-item v-for="(item, index) in profiles" :key="index" class="profiles_item">

                <div class="control-panel">
                    <div @click="onSignInAsUser(item)" class="control-panel-item" style="color: #1976D2">
                        <i class="fas fa-sign-in-alt"></i>
                    </div>
                </div>
                <div class="menu">
                    <b-dropdown no-caret class="template_d">
                        <b-dropdown-item
                            @click.stop="onOpenProfileSetting(item)">
                            <img src="@/assets/icons/ic_gear.svg">
                            <span>Change role</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click.stop="onMenuPinClick(item)">
                            <img src="@/assets/icons/ic_pin_change.svg" v-if="item.has_pin">
                            <img src="@/assets/icons/ic_pin_set.svg" v-else>
                            <span v-if="item.has_pin">Change pin</span>
                            <span v-else>Set pin</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click.stop="onMenuUserNameClick(item)">
                            <img src="@/assets/icons/ic_set_username.svg">
                            <span>{{ item.username ? 'Change username' : 'Set username' }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click.stop="deleteProfileClick(item)">
                            <img src="@/assets/icons/ic_delete.svg">
                            <span>Delete user</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="profiles_top">
                    <h5 class="mb-0">{{item.first_name}} {{item.last_name}}</h5>
                    <span class="profiles-role">{{JSON.parse(JSON.stringify(item.role))}} ({{item.setups.lang_code == null ? 'null' : item.setups.lang_code}})</span>
                    <span class="profile-username" v-if="item.username">{{item.username}}</span>
                    <span>{{item.email}}</span>
                    <span>UID: {{item.guid}}</span>
                    <div>
                        <span>{{item.created_at | moment("HH:mm:ss D.MM.YYYY ")}} ( {{ item.provider }} )</span>
                    </div>
                    <div>
                        <span>Last active: {{item.last_active_at | moment("HH:mm:ss D.MM.YYYY ")}}</span><a class="activity" v-if="item.last_active_at" :href="`/admin/users/actions?s=${item.email}`">(activity)</a>
                    </div>
                </div>

                <div class="profiles_organization" v-if="item.organization">
                    <h6>{{item.organization.official_name}}</h6>
                    <span>{{item.organization.guid}}</span>
                    <div class="profiles_organization_place" v-if="item.organization.place">
                        <div>
                            <img :src="item.organization.place.preview">
                        </div>
                        <div>
                            <h6>{{item.organization.place.name}}</h6>
                            <div>{{item.organization.place.address}}</div>
                            <div>{{item.organization.place.uid}}</div>
                        </div>
                    </div>
                </div>
            </b-list-group-item>
            <infinite-loading :identifier="infiniteProfile" @infinite="getProfiles">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>
        <b-modal v-model="profileSettingsModal" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="close"></span>
            </template>

            <vSelect
                    v-if="selectedProfile"
                    v-model="selectedRole"
                    label="text"
                    :clearable="false"
                    :searchable="false"
                    :options="defaultRoles">
            </vSelect>

            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="profileSettingsModal = false">
                    {{ translate('Cancel') }}
                </b-button>

                <b-button variant="primary" :disabled="loadingAction" @click="onSaveRole">
                    {{ translate('admin_SaveRole') }}
                </b-button>

            </template>

        </b-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import customModalDialog from '@/components/widgets/customModalDialog';
import customModalSidebar from '@/components/widgets/customModalSidebar';
import translate from "@/helpers/translate"
import vSelect from "vue-select";
import errorMixin from "@/mixins/errorMixin";
import adminStickyHeaderMixin from "@/mixins/adminStickyHeaderMixin";
import adminPageMixin from "@/mixins/adminPageMixin";

export default {
        mixins: [errorMixin, adminStickyHeaderMixin, adminPageMixin,],
        name: "Profiles",
        components: {
            InfiniteLoading,
            customModalDialog,
            customModalSidebar,
            vSelect,
        },
        data() {
            return {
                searchProfile: '',
                profilesConfig: {
                    orderBy: 'date_added',
                    orderDir: 'desc',
                },
                infiniteProfile: 0,
                profiles: [],
                customSidebarSettings: {},
                customModalSettings: {},
                profileSettingsModal: false,
                selectedProfile: null,
                loadingAction: false,
                page: 1
            }
        },
        watch: {
            searchProfile(value) {
                this.refreshProfiles()
            },
            infinity(val) {
                this.page = 1
                this.infiniteProfile += 1
            },
        },
        props: ['infinity'],
        computed: {
            ...mapState({
                defaultRoles: state => state.auth.defaultRoles,
            }),
            ...mapGetters({
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                isUserSiteManager: 'auth/isUserSiteManager',
                isUserOrgManager: 'auth/isUserOrgManager',
                getUserOrgIds: 'auth/getUserOrgIds',
            }),
            selectedRole: {
                get() {
                    const role = this.selectedProfile.role.charAt(0).toUpperCase() + this.selectedProfile.role.slice(1);
                    return translate(role)
                },

                set({value}) {
                    this.selectedProfile.role = value
                }
            },
        },
    mounted() {
        this.initAdminPage()
    },
        methods: {
            ...mapActions({
                fetchProfilesActions: 'profiles/fetchProfiles',
                deleteProfile: 'profiles/deleteProfile',
                createNewUserManually: 'profiles/createNewUserManually',
                signInAsUser: 'auth/signInAsUser',
                saveRole: 'auth/saveRole',
                setPin: 'auth/setPin',
                setUserName: 'auth/setUserName',
            }),
            ...mapMutations({
                addProfiles: 'profiles/addProfiles',
                resetProfiles: 'profiles/resetProfiles',
                setProgressBarTag: 'setProgressBarTag',
            }),
            async getProfiles(stateInf) {
                try {
                    this.loadingAction = true
                    const response = await this.fetchProfilesActions({
                        page: this.page,
                        search: this.searchProfile || null,
                        order_by: this.profilesConfig.orderBy,
                        order_dir: this.profilesConfig.orderDir
                    });
                    if (response.success) {
                        if(this.page == 1) {
                            this.profiles = []
                        }
                        this.page += 1
                        response.users.forEach((item) => {
                            if(!item.username) {
                                item.username = null
                            }
                            this.profiles.push(item)
                        })
                    }
                    if (stateInf) {
                        if (response.users.length === 10) {
                            stateInf.loaded();
                        } else {
                            stateInf.complete();
                        }
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message)
                } finally {
                    this.loadingAction = false
                }
            },
            async onSaveNewUser(obj) {
                let data = {}
                obj.input.forEach(element => {
                    if (element.request_name != null) {
                        data[element.request_name] = element.value
                    }
                })
                obj.checkboxes.forEach(checkbox => {
                    console.log(`checkbox:`, checkbox)
                    if (checkbox.id == 'email_confirmed') {
                        data['confirmed'] = checkbox.checked
                    }
                    if (checkbox.id == 'quick_start_guide_flag') {
                        data['quick_start_email'] = {
                            send: checkbox.checked,
                            delay: obj.input.find(item => item.id == 'quick_start_guide_delay').value
                        }
                    }
                })
                let langDropdown = obj.dropdowns.find(dropdown => dropdown.id == 'user_lang')
                if (langDropdown != null) {
                    data['lang_code'] = langDropdown.items[langDropdown.active].value
                }
                try {
                    const responce = await this.createNewUserManually(data);
                    if (responce.success) {
                        this.customSidebarSettings = {}
                        this.customModalSettings = {
                            sectionClass: 'full-width--btn',
                            icon: 'ic_allow.svg',
                            title: this.translate('admin_success'),
                            message: this.translate('admin_userCreated')
                        }
                        this.infiniteProfile += 1
                        this.page = 1
                        this.resetProfiles()
                        this.refreshProfiles()
                    } else {
                        this.showErrorModal('Error', {title: 'CancelRequest'})
                    }
                } catch (e) {
                    if (e.data.error.code == 400) {
                        this.showErrorModal(e.data.error.message, {title: 'CancelRequest'})
                    }
                }

            },
            async onDeleteProfileAction(item, settings) {
                const index = this.profiles.indexOf(item)
                try {
                    const response = await this.deleteProfile({
                        item: item,
                    })
                    if (response) {
                        if (index) {
                            this.profiles.splice(index, 1)
                        }
                    }
                    this.refreshProfiles()
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            async onSaveRole() {
                try {
                    this.loadingAction = true
                    await this.saveRole(this.selectedProfile)
                    this.profileSettingsModal = false
                    const profile = this.profiles.find(item => item.guid === this.selectedProfile.guid)
                    profile.role = this.selectedProfile.role

                    this.customModalSettings = {
                        message: this.translate('admin_successMessageChangeRole'),
                        okButtonText: this.translate('yes'),
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingAction = false
                }
            },

            deleteProfileClick(item) {
                this.customModalSettings = {
                    message: this.translate('admin_deleteRole', [item.first_name, item.last_name]),
                    onOkHandler: this.onDeleteProfileAction.bind(null, item),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            onAddUserClick() {
                this.customSidebarSettings = {
                    title: this.translate('createNewUser'),
                    cancel: true,
                    input: [
                        {
                            label: this.translate('admin_firstName'),
                            value: '',
                            count: 30,
                            request_name: 'first_name'
                        },
                        {
                            label: this.translate('admin_lastName'),
                            value: '',
                            count: 30,
                            request_name: 'last_name',
                        },
                        {
                            label: this.translate('admin_contactEmail'),
                            value: '',
                            count: 50,
                            request_name: 'contact_email',
                        },
                        {
                            label: this.translate('admin_phone'),
                            value: '',
                            count: 50,
                            request_name: 'phone',
                        },
                        {
                            label: 'QuickStartGuide delay (mins)',
                            value: '5',
                            count: 10,
                            id: 'quick_start_guide_delay',
                        }
                    ],
                    checkboxes: [
                        {
                            checked: false,
                            id: 'email_confirmed',
                            title: 'Email confirmed'
                        },
                        {
                            checked: false,
                            id: 'quick_start_guide_flag',
                            title: 'Send QuickStartGuide email'
                        }
                    ],
                    dropdowns: [
                        {
                            active: 0,
                            name: 'User language:',
                            id: 'user_lang',
                            items: [{name: 'en', value: 'en'}, {name: 'ru', value: 'ru'},
                                {name: 'uk', value: 'uk'}, {name: 'unknown (set on signup)', value: null}]
                        },
                    ],
                    buttons: [
                        {
                            text: this.translate('Save'),
                            action: this.onSaveNewUser,
                            classList: 'invert_btn'
                        }
                    ]
                }
            },

            onSignInAsUser(item) {
                this.customModalSettings = {
                    message: this.translate('admin_signInAs', [(item.first_name + ' ' + item.last_name)]),
                    onOkHandler: this.signInAsUserAction.bind(null, item),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },
            async signInAsUserAction(item) {
                try {
                    await this.signInAsUser({
                        guid: item.guid
                    })
                    if (this.isUserAdmin) {
                        this.$router.push({name: 'adminPanel'})
                    } else if (this.isUserOwner || this.isUserOrgManager || this.isUserSiteManager) {
                        if(this.getUserOrgIds.includes(719)) {//republic services
                            this.$router.push({name: 'ServiceLogsDashboard'})
                        } else {
                            this.$router.push({name: 'OwnerPlaceManagement'})
                        }
                    } else {
                        this.$router.push({name: 'Login'});
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },

            onMenuPinClick(item, pin = '') {
                this.customModalSettings = {
                    user: item,
                    message: item.has_pin ? 'Change pin' : 'Set pin',
                    input: {
                        label: 'Enter pin code (4 digits)',
                        placeholder: 'Enter pin code',
                        value: pin,
                        type: 'number',
                    },
                    onOkHandler: this.onPinSetClick,
                    showCancelButton: true,
                    okButtonText: 'Save',
                    cancelButtonText: 'Cancel',
                }
            },
            async onPinSetClick(settings) {
                let user = settings.user
                let pin = settings.input.value
                let onlyDigits = /^\d+$/.test(pin);
                if(pin.length != 4) {
                    this.showErrorModal('Pin enter 4 digits')
                    this.onMenuPinClick(user, pin)
                    return
                }
                if(!onlyDigits) {
                    this.showErrorModal('Pin should contain only digits')
                    this.onMenuPinClick(user, pin)
                    return
                }
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'set_user_pin'
                    })
                    await this.setPin({userGuid: user.guid, pin: pin})
                    user.has_pin = true
                    this.customModalSettings = {
                        message: 'New pin code saved',
                        okButtonText: this.translate('yes'),
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'set_user_pin'
                    })
                }
            },
            onMenuUserNameClick(item, username = '') {
                this.customModalSettings = {
                    user: item,
                    message: item.username ? 'Change username' : 'Set username',
                    input: {
                        label: 'Enter username (case insensitive)',
                        placeholder: 'username',
                        value: username || item.username || '',
                        type: 'text',
                    },
                    onOkHandler: this.onUserNameSetClick,
                    showCancelButton: true,
                    okButtonText: 'Save',
                    cancelButtonText: 'Cancel',
                }
            },
            async onUserNameSetClick(settings) {
                let user = settings.user
                let username = settings.input.value
                if(username.length < 4) {
                    this.showErrorModal('Enter at least 4 symbols')
                    this.onMenuUserNameClick(user, username)
                    return
                }
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'set_username'
                    })
                    await this.setUserName({userGuid: user.guid, username: username})
                    user.username = username
                    this.customModalSettings = {
                        message: 'New username saved',
                        okButtonText: this.translate('yes'),
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'set_username'
                    })
                }
            },
            onOpenProfileSetting(item) {
                this.selectedProfile = JSON.parse(JSON.stringify(item))
                this.profileSettingsModal = true
            },


            onSortChangedBy(value) {
                this.profilesConfig.orderBy = value
                this.refreshProfiles()
            },

            onSortChangedDir(value) {
                this.profilesConfig.orderDir = value
                this.refreshProfiles()
            },
            refreshProfiles() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer);
                }
                this.searchTimer = setTimeout(() => {
                    this.infiniteProfile += 1
                    this.page = 1
                    this.profiles = []
                }, 450);
            },
            onListScrolled(element) {
                this.fixStickyHeader(element.srcElement.scrollTop)
            },
        }
    }
</script>

<style scoped>
    .profiles_list {
        max-height: calc(100vh - 62px);
        overflow: auto;
        margin-bottom: 0;
        font-size: .7em;
        width: 100%;
        min-width: 100%;
    }

    .profiles_list .sign-in-as-user {
        background: #1976D2;
        color: #fff;
    }

    .profiles_item {

        display: table;
        width: 100%;
        min-width: 100%;
        flex-direction: column;
        width: 100%;
        align-items: flex-start;
    }

    .profiles_top {
        display: flex;
        flex-direction: column;
    }

    .profiles_search {
        display: flex;
    }

    .profiles_sort_by {
        display: flex;
        padding-top: 7px;
        padding-left: 20px;
    }

    .profiles_sort_dir {
        display: flex;
        padding-top: 7px;
        padding-left: 20px;
    }

    .profiles_sort_link {
        color: black;
        text-decoration: none !important;
        outline: none;
    }

    .profiles_sort_icon {
        height: 20px;
        color: black;
        margin-left: 10px;

    }

    .profiles_sort_icon.active {
        border: 2px solid black;
        border-radius: 5px;
        padding: 5px;
    }

    .profiles_sort_link.active {
        border-bottom: 2px solid black;
    }

    .profiles_top h5 {
        font-weight: bold;
        font-size: 1.5em;
        padding-right: 40px;
    }

    .profiles-role {
        font-size: 14px;
    }
    .profile-username {
        font-size: 13px;
        color: #001476;
    }

    .profiles_search_group {
        display: flex;
    }

    .search_profiles {
        width: 900px;
        margin-bottom: 7px;
        margin-left: 0.8em;
    }

    .search_votes {
        width: 350px;
        margin-bottom: 7px;
        margin-left: 12px;
    }

    .profiles_organization {
        border: 1px solid rgba(0, 0, 0, 0.075);
        width: 100%;
        margin-top: .35em;
        padding: .35em;
    }

    .profiles_organization_place {
        border: 1px solid rgba(0, 0, 0, 0.075);
        display: flex;
        flex-direction: row;
        padding: .35em;
        margin-top: .5em;
    }

    .profiles_organization_place img {
        width: 3em;
        height: 3em;
        transform: scale(1);
    }
    .control-panel {
        margin-right: 26px;
    }
    .menu {
        position: absolute;
        top: 8px;
        right: 8px;
    }
    .dropdown.template_d /deep/ button.btn-secondary:before {
        content: '';
        background-image: url("~@/assets/icons/ic_kebab.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        display: block;
        position: relative;
        left: 0;
        top: 0;
        bottom: 0;
        width: 22px;
        height: 22px;
    }
    .dropdown.template_d /deep/ button.btn-secondary {
        background: none !important;
        border: 0;
        display: flex;
        align-items: center;
        color: #2F2F2F;
        font-size: 14px;
        padding: 0;
        padding-left: 7px;
        font-weight: 600;
        justify-content: flex-end;
    }

    .activity {
        text-decoration: underline !important;
        cursor: pointer;
        color: #174289 !important;
    }

    @media screen and (max-width: 1395px) {
        .search_profiles {
            width: 600px;
        }

    }

    @media screen and (max-width: 1024px) {
        .profiles_search_group {
            display: flex;
            flex-direction: row;
        }

        .profiles_search {
            display: flex;
            flex-direction: column;
        }

        .search_profiles {
            width: 100%;
        }

        .search_votes {
            width: calc(100% - 24px);
            margin-right: 12px;
        }
    }
    @media screen and (max-width: 505px) {
        .profiles_search_group {
            display: flex;
            flex-direction: column;
        }
    }
</style>
